import * as Yup from "yup"
import { Message } from "../helpers/language_helper"

export const quizPageValidation = Yup.object().shape({
  name: Yup.string().trim().required(Message("Name.required")).nullable(),
  dateRangeMin: Yup.date().required(Message("FromDate.required")),
  dateRangeMax: Yup.date().required(Message("ToDate.required")),
})

export const schoolFormValidation = Yup.object().shape({
  name: Yup.string().trim().required(Message("Name.required")).nullable(),
  email: Yup.string()
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, Message("email.invalid"))
    .required(Message("email.required")),
})

export const userPageValidation = Yup.object().shape({
  name: Yup.string().trim().required(Message("Name.required")).nullable(),
  mobileNumber: Yup.string()
    .trim()
    .required(Message("mobileNumber.required"))
    .nullable(),
})
export const teacherPageValidation = Yup.object().shape({
  name: Yup.string().trim().required(Message("Name.required")).nullable(),
})
export const quizQuestionPageValidation = Yup.object().shape({
  question: Yup.string()
    .trim()
    .required(Message("Question.required"))
    .nullable(),
  optionA: Yup.string().required(Message("Option A.required")).nullable(),
  optionB: Yup.string().required(Message("Option B.required")).nullable(),
  optionC: Yup.string().required(Message("Option C.required")).nullable(),
})

export const merchantValidation = Yup.object().shape({
  merchantName: Yup.string().required(Message("Name.required")).nullable(),
  mobileNumber: Yup.string()
    .matches(/^[6789][0-9]{9}$/, Message("Mobile.invalid"))
    .required(Message("mobileNumber.required")),
  description: Yup.string()
    .required(Message("description.required"))
    .nullable(),
  address: Yup.string().required(Message("address.required")).nullable(),
})

export const assessmentValidation = Yup.object().shape({
  assessmentName: Yup.string().required(Message("Name.required")).nullable(),
})

export const taskMasterValidation = Yup.object().shape({
  taskName: Yup.string().required(Message("Name.required")).nullable(),
})

export const ageGroupValidation = Yup.object().shape({
  ageGroupTitle: Yup.string()
    .trim()
    .required(Message("ageGroupTitle.required"))
    .nullable(),
  upperAgeLimit: Yup.string().required(Message("AgeLimit.required")).nullable(),
  lowerAgeLimit: Yup.string().required(Message("AgeLimit.required")).nullable(),
})

export const CMSValidation = Yup.object().shape({
  name: Yup.string().trim().required(Message("Name.required")).nullable(),
  content: Yup.string().required(Message("content.required")).nullable(),
})

export const loginValidation = Yup.object().shape({
  mobileNumber: Yup.string().required(Message("username.required")),
  password: Yup.string().required(Message("password.required")),
  // .min(8, Message("password.lengthinvalid"))
  // .matches(
  //  /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
  //  Message("password.invalid")
  // ),
})

export const changePasswordValidation = Yup.object().shape({
  Password: Yup.string().required(Message("Password.required")),
  NewPassword: Yup.string().required(Message("NewPassword.required")),
  ConfirmPassword: Yup.string().required(Message("ConfirmPassword.required")),
})
export const forcePasswordChangeValidation = Yup.object().shape({
  Password: Yup.string().required(Message("Password.required")),
  NewPassword: Yup.string().required(Message("NewPassword.required")),
  ConfirmPassword: Yup.string().required(Message("ConfirmPassword.required")),
})
export const forgotPasswordValidation = Yup.object().shape({
  Username: Yup.string().required(Message("username.required")),
})

export const confirmPasswordValidation = Yup.object().shape({
  NewPassword: Yup.string().required(Message("NewPassword.required")),
  ConfirmPassword: Yup.string().required(Message("ConfirmPassword.required")),
})

export const homepageImageValidation = Yup.object().shape({
  name: Yup.string().required(Message("name.required")),
  image: Yup.string().required(Message("name.required")),
  isActive: Yup.string().required(Message("department.required")).nullable(),
})
